export default __webpack_public_path__ + "static/media/communication.9c3a0298.png";